import React, { useState } from 'react'
import PropTypes from 'prop-types'

import BannerPreview from '../BannerPreview'

const PositionPreview = ({ description }) => {
  const [openBanner, setOpenBanner] = useState(false)

  return (
    <BannerPreview
      openBanner={openBanner}
      setOpenBanner={setOpenBanner}
      description={description}
    />
  )
}

PositionPreview.propTypes = {
  description: PropTypes.string,
}

export default PositionPreview
